import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  createLocation,
  getStates,
  getCitiesByState,
  getBrandsForFilter,
  getAccountsForFilter,
  getInstallersByAccount,
  getWaterFilterConfigurationsForFilter,
  getReverseOsmosisConfigurationsForFilter,
  getSoftenerConfigurationsForFilter,
  getAdminsLocations,
} from 'actions/index';
import { Colors } from 'modules/theme';
import { push } from 'modules/history';
import Icon from 'components/Icon';
import H2 from 'components/H2';
import Stepper from 'components/Stepper';
import PropTypes from 'prop-types';
import { DeviceTypes } from 'constants/index';
import DetailsForm from './DetailsForm';
import ConfigurationForm from './ConfigurationForm';
import InstallerForm from './InstallerForm';

const Container = styled.div`
  box-sizing: border-box;
  max-width: 100%;
  margin: 20px;
  overflow-x: hidden;
  padding-bottom: 24px;
  @media (max-width: 767px) {
    margin: 20px auto;
    padding-left: 16px;
    padding-right: 16px;
  }
  @media (min-width: 768px) {
    margin: 30px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

const Column = styled.div`
  flex-direction: column;
  align-self: center;
  margin-right: 10px;
  margin-bottom: 10px;
  @media (max-width: 767px) {
    margin-right: 0;
  }
`;

class CreateLocation extends Component {
  state = {
    activeTab: 'Details',
    location: {
      identificator: '',
      account_id: '',
      address_line: '',
      address_line_1: '',
      brand_id: '',
      city_id: '',
      admin_email: '',
      admin_first_name: '',
      admin_last_name: '',
      admin_phone_number: '',
      admin_position: '',
      select_user: 'new_user',
      createNewUser: true,
      isPointOfContact: true,
      location_admin_id: null,
      state_id: '',
      zip_code: '',
      waterFilter: {
        water_filter_config_id: '',
        chlorine_or_chloramine: 'Chlorine',
        flowMeterOfWaterFilters: [],
      },
      reverseOsmosis: {
        ro_filter_config_id: '',
        chlorine_or_chloramine: 'Chlorine',
        low_inlet_pressure: 25,
        flowMeterOfROFilters: [],
      },
      waterSoftener: {
        softener_configuration_id: '',
        description: '',
      },
      installer_first_name: '',
      installer_last_name: '',
      installer_email: '',
      installer_phone_number: '',
      installer_company_name: '',
      estimated_install_date_from: new Date(),
      estimated_install_date_to: new Date(),
    },
  };

  componentDidMount() {
    const {
      fetchStates,
      fetchBrands,
      fetchWaterFilterConfigurations,
      fetchReverseOsmosisConfigurations,
      fetchSoftenerConfigurations,
    } = this.props;

    fetchStates();
    fetchBrands();
    fetchWaterFilterConfigurations();
    fetchReverseOsmosisConfigurations();
    fetchSoftenerConfigurations();
  }

  saveData = (data, nextTab, persistLocation = false) => {
    const { location /* activeTab */ } = this.state;
    const locationUpdated = {
      ...location,
      ...data,
    };

    if (nextTab === 'Installer') {
      const { fetchInstallers } = this.props;
      const { account_id } = locationUpdated;
      fetchInstallers(account_id);
    }

    if (persistLocation) {
      const { submitLocation } = this.props;
      submitLocation(locationUpdated);
    } else {
      this.setState({
        activeTab: nextTab,
        location: locationUpdated,
      });
    }
  };

  back = backTab => {
    this.setState({
      activeTab: backTab,
    });
  };

  switchTab = activeTab => {
    this.setState({ activeTab });
  };

  filterDeviceTypes = () => {
    const { location } = this.state;
    return DeviceTypes.filter(device => {
      switch (device.value) {
        case 'water-filter':
          return location.waterFilter && location.waterFilter.water_filter_config_id !== '';
        case 'reverse-osmosis':
          return location.reverseOsmosis && location.reverseOsmosis.ro_filter_config_id !== '';
        case 'water-softener':
          return location.waterSoftener && location.waterSoftener.softener_configuration_id !== '';
        default:
          return false;
      }
    });
  };

  getAdminsBrandsLocations = accountId => {
    const { fetchAdminsLocations } = this.props;
    fetchAdminsLocations(accountId);
  };

  render() {
    const {
      /*  submitLocation, */
      brands,
      accounts,
      states,
      cities,
      installers,
      waterFilterConfigurationsForFilter,
      reverseOsmosisConfigurationsForFilter,
      softenerConfigurationsForFilter,
      fetchCities,
      fetchAccounts,
      loading,
      adminsLocations,
    } = this.props;
    const { activeTab, location } = this.state;

    const steps = [{ title: 'Details' }, { title: 'Configuration' }, { title: 'Installer' }];

    const additionalOptions =
      adminsLocations.length > 0
        ? adminsLocations.map(admin => ({
            label: `${admin.first_name} ${admin.last_name}`,
            value: admin.id,
          }))
        : [];

    return (
      <Container>
        <Row>
          <Column>
            <Icon onClick={() => push('/locations')} name="chevron-left" color={Colors.blue} />
          </Column>
          <Column>
            <H2 color={Colors.black} style={{ paddingRight: 30 }}>
              Add new location
            </H2>
          </Column>
        </Row>
        <Stepper
          steps={steps}
          activeStep={activeTab}
          onStepClick={idx => this.switchTab(steps[idx].title)}
        />

        {activeTab === 'Details' && (
          <DetailsForm
            initialValues={location}
            additionalOptions={additionalOptions}
            brands={brands}
            accounts={accounts}
            cities={cities}
            states={states}
            fetchCities={fetchCities}
            fetchAccounts={fetchAccounts}
            onSubmit={this.saveData}
            getAdminsBrandsLocations={this.getAdminsBrandsLocations}
          />
        )}
        {activeTab === 'Configuration' && (
          <ConfigurationForm
            initialValues={location}
            waterFilterConfigurationsForFilter={waterFilterConfigurationsForFilter}
            reverseOsmosisConfigurationsForFilter={reverseOsmosisConfigurationsForFilter}
            softenerConfigurationsForFilter={softenerConfigurationsForFilter}
            back={this.back}
            onSubmit={this.saveData}
            waterFilterDisabled={false}
            reverseOsmosisDisabled={false}
            softenerDisabled={false}
          />
        )}
        {activeTab === 'Installer' && (
          <InstallerForm
            initialValues={location}
            installers={installers}
            back={this.back}
            onSubmit={this.saveData}
            loading={loading}
          />
        )}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.locations.loading,
    brands: state.brands.listForFilter,
    accounts: state.accounts.listForFilter,
    states: state.utils.states,
    cities: state.utils.cities,
    installers: state.users.installers,
    waterFilterConfigurationsForFilter: state.libraries.waterFilterConfigurationsForFilter,
    reverseOsmosisConfigurationsForFilter: state.libraries.reverseOsmosisConfigurationsForFilter,
    softenerConfigurationsForFilter: state.libraries.softenerConfigurationsForFilter,
    adminsLocations: state.brands.adminsLocations,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    submitLocation: alertType => dispatch(createLocation(alertType)),
    fetchStates: () => dispatch(getStates()),
    fetchCities: stateId => dispatch(getCitiesByState(stateId)),
    fetchBrands: () => dispatch(getBrandsForFilter()),
    fetchAccounts: params => dispatch(getAccountsForFilter(params)),
    fetchInstallers: accountId => dispatch(getInstallersByAccount(accountId)),
    fetchWaterFilterConfigurations: type => dispatch(getWaterFilterConfigurationsForFilter(type)),
    fetchReverseOsmosisConfigurations: type =>
      dispatch(getReverseOsmosisConfigurationsForFilter(type)),
    fetchSoftenerConfigurations: type => dispatch(getSoftenerConfigurationsForFilter(type)),
    fetchAdminsLocations: accountId => dispatch(getAdminsLocations(accountId)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateLocation);
// add the proptypes and sort them alphabetically

CreateLocation.propTypes = {
  accounts: PropTypes.array,
  adminsLocations: PropTypes.array,
  brands: PropTypes.array,
  cities: PropTypes.array,
  fetchAccounts: PropTypes.func,
  fetchAdminsLocations: PropTypes.func,
  fetchBrands: PropTypes.func,
  fetchCities: PropTypes.func,
  fetchInstallers: PropTypes.func,
  fetchReverseOsmosisConfigurations: PropTypes.func,
  fetchSoftenerConfigurations: PropTypes.func,
  fetchStates: PropTypes.func,
  fetchWaterFilterConfigurations: PropTypes.func,
  installers: PropTypes.array,
  loading: PropTypes.bool,
  reverseOsmosisConfigurationsForFilter: PropTypes.array,
  softenerConfigurationsForFilter: PropTypes.array,
  states: PropTypes.array,
  submitLocation: PropTypes.func,
  waterFilterConfigurationsForFilter: PropTypes.array,
};
